import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Pagination } from '@shared/models/pagination.model';
import { BaseService } from '@shared/services/base.service';
import { Observable, map } from 'rxjs';

import { StockListNegativeCount, StockListPagination, StockListSearchCriteria } from '../models/stock-list.model';
import {
  AdjustTransaction,
  StockInfoBarcode,
  StockMovementList,
  StockMovementListSearchCriteria,
  StockView
} from '../models/stock-view.model';

@Injectable({
  providedIn: 'root'
})
export class StockService extends BaseService {
  public override headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.stock;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  getList(criteria: StockListSearchCriteria): Observable<StockListPagination> {
    const storeNo = this.retrieveStore().storeNo;
    const url = this.getFullUrl(this.envService.list, { storeNo });
    const params = this.getParams(criteria, true);

    return this.http
      .get<any>(url, {
        headers: this.loaderHeaders(null),
        observe: 'body',
        params
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  getStockListNativeCount(): Observable<StockListNegativeCount> {
    const url = this.getFullUrlWithStoreCode(this.envService.negativeListCount);
    return this.http
      .get<any>(url, {
        headers: this.loaderHeaders(null),
        observe: 'body'
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  getStockSummary(id: string): Observable<StockView> {
    const url = this.getFullUrlWithStoreCode(this.envService.summary, { articleNo: id });
    return this.http.get<any>(url, {
      headers: this.loaderHeaders(),
      observe: 'body',
      responseType: 'json'
    });
  }

  getStockBarcode(id: string): Observable<StockInfoBarcode[]> {
    const url = this.getFullUrl(this.envService.barcode, {
      articleNo: id
    });

    return this.http.get<StockInfoBarcode[]>(url, {
      headers: this.loaderHeaders(),
      observe: 'body',
      responseType: 'json'
    });
  }

  getMovementList(criteria: StockMovementListSearchCriteria): Observable<Pagination<StockMovementList>> {
    const url = this.getFullUrlWithStoreCode(this.envService.movement, { articleNo: criteria.articleNo });
    const params = this.getParams(criteria, true);

    return this.http
      .get<any>(url, {
        headers: this.loaderHeaders(null),
        observe: 'body',
        params
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  adjustTransaction(articleNo: string): Observable<AdjustTransaction[]> {
    const storeCode = this.retrieveStore().storeCode;
    const url = this.getFullUrl(this.envService.adjustTransaction, {
      storeCode,
      articleNo: articleNo
    });

    return this.http.get<AdjustTransaction[]>(url, {
      headers: this.loaderHeaders(),
      observe: 'body',
      responseType: 'json'
    });
  }
}
